import Chip from '@material-ui/core/Chip';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

class Project extends Component {

  render() {

    const { project, classes } = this.props;

    return (
      <div className="project">

        <div className="project-header">
          <h4>{ project.title }</h4>
        </div>

        <div>

          <div className="project-body">

            <div className="left">
              <div>
                <h3>About</h3>
                <p className="about">{ project.about }</p>
              </div>
            </div>

            <div className="right">
              <h3>Links</h3>
              <ul>
              { project.links.map(link => (
                <li><a className="vanilla" href={ link.url }>{ link.title }</a></li>
              )) }
              </ul>
            </div>

          </div>

          <div>
            <h3>Technologies</h3>
            { project.techs.map(tech => <Chip className={ classes.chip } label={ tech } /> ) }
          </div>

        </div>

      </div>
    )
  }

}

Project.propTypes = {
  project: PropTypes.array.isRequired,
};

const styles = {
  chip: {
    color: 'white',
    backgroundColor: 'rgba(91, 155, 255, 0.29)',
    marginRight: 5,
    marginBottom: 5
  }
};

export default withStyles(styles)(Project);



// WEBPACK FOOTER //
// ./src/components/Project/Project.js